import types from './types';

const receiveOmniCountries = (countries) => ({
  type: types.RECEIVE_ALL_OMNI_COUNTRIES,
  data: countries
});

export default { receiveOmniCountries };
